/**
 * Annule le rendez-vous et remet la plage disponible
 * @param {any} rendezVousId : identifiant du rendez-vous
 */
async function cancelRendezVousAsync(RendezVousId) {

    let httpRequestUrl = '/api/rendezvous/cancelrendezvous';

    return axios.put(httpRequestUrl,
        {
            RendezVousId: RendezVousId
        },
        {
            headers: {
                RequestVerificationToken: $("[name='__RequestVerificationToken']").val()
            }
        })
        .then(function (response) {
            console.log(response);
            return Promise.resolve(response.data);
        })
        .catch(function (error) {
            console.log(error);
            if (error.response) {
                if (error.response.status = 203) {
                    window.location.href = '/user/mustbeloggedin';
                }
            }
            return Promise.reject(error);
        });

}
window.cancelRendezVousAsync = cancelRendezVousAsync;


/**
 * Retour au panneau du calendrier
 */
function ReturnToCal() {

    $('#rdvTitle').text(LBLTakeRDV);
    $('#rdvBack').off('click');
    $('#rdvBack').on('click', function () {

        CloseRDV();
    });

    AfficherCalendrier();

}
window.ReturnToCal = ReturnToCal;

/**
 * Affiche les différents composants des RDV
 * @param {any} section Section à afficher
 */
function ShowRDVSection(section) {

    switch (section) {

        case 'calendar': //calendrier
            $('.rdvPanelContainer').css('background-color', 'white');
            $('#rdvCalendarContainer').show();
            $('.rangeContainer').hide();
            $('.hoursContainer').hide();
            $('.rdvPanelRDVBtn').hide();
            $('.rdvSelectDate').css('display', 'flex');
            $('.rdvSelectHour').hide().removeClass('d-flex');
            bottomControlOpen = false;
            RDVPanelPos(true);
            break;
        case 'hourrange': //liste des plages d'heures
            $('.rdvPanelContainer').css('background-color', 'white');
            $('#rdvCalendarContainer').hide();
            $('.rangeContainer').show();
            $('.hoursContainer').hide()
            $('.RDVNoRDV').hide();
            $('.rdvPanelRDVBtn').hide();
            bottomControlOpen = false;
            RDVPanelPos(true);
            break;
        case 'hourselect': //Liste des heures
            $('.rdvPanelContainer').css('background-color', 'white');
            $('#rdvCalendarContainer').hide();
            $('.rangeContainer').hide();
            $('.hoursContainer').show();
            $('.rdvPanelRDVBtn').show();
            $('.rdvSelectDate').hide().removeClass('d-flex');
            $('.rdvSelectHour').css('display', 'flex');
            bottomControlOpen = true;
            RDVPanelPos(false);
            break;
        case 'hide': //cache tout
            $('.rdvPanelContainer').css('background-color', 'white');
            $('#rdvCalendarContainer').hide();
            $('.rangeContainer').hide();
            $('.hoursContainer').hide();
            $('.rdvPanelRDVBtn').hide();
            $('.rdvSelectDate').hide().removeClass('d-flex');
            $('.rdvSelectHour').hide().removeClass('d-flex');
            $('.rdvPanel').hide();
            $('.rightPanelRDVBtn').hide();
            bottomControlOpen = false;
            RDVPanelPos();
            break;
        default:
            $('.rdvPanelContainer').css('background-color', 'white');
            $('#rdvCalendarContainer').hide();
            $('.rangeContainer').show();
            $('.hoursContainer').hide();
            $('.rdvPanelRDVBtn').hide();
            bottomControlOpen = false;
            RDVPanelPos();
            $('.RDVNoRDV').show();
    }

}
window.ShowRDVSection = ShowRDVSection;

/**
 * Affiche le résultat des plages d'heures
 */
function ShowRangeResult() {

    RightPanelPos(true);

    $('.RDVRangeHeader').show();
    $('.RDVNoRDV').hide();
    $('.View1Day').hide();
    $('.rdvPanelContainer').css('padding-bottom', '100px').css('background-color', 'white');
    $('.rangeContainer').show();
    $('.rdvPanelRDVBtn').hide();
}
window.ShowRangeResult = ShowRangeResult;

/**
 * Cache le résultat des plages d'heures
 */
function HideRangeResult() {

    RightPanelPos();

    $('.RDVRangeHeader').hide();
    $('.rdvPanelContainer').css('padding-bottom', '0px').css('background-color', 'white');
    $('.RDVNoRDV').show();
    $('.rangeContainer').hide();
    $('.rdvPanelRDVBtn').show();
}
window.HideRangeResult = HideRangeResult;



/**
 * Annulation d'un rendez-vous
 * @param {any} RDVId Id du rdv
 * @param {any} nom   Nom de la collecte du rdv a annuler
 * @param {any} type Type de don
 * @param {boolean} desuet desuet  S'il s'agit d'un rdv désuet
 * @param {any} typeCol Type de collecte
 */
function CancelRDV(RDVId, nom, type, desuet, typeCol) {

    if (!desuet) {
        $("#mi-modal").modal('show');

        Analytics('gaEvent', 'rendez-vous', 'annulation de rendez-vous', 'intention d\'annulation');

        $("#modal-btn-si").on("click", function () {
            CancelConfirmed(RDVId, nom, type, desuet, typeCol)
        });


        $("#modal-btn-no").on("click",
            function () {
                $("#mi-modal").modal('hide');
            });
    } else {
        CancelConfirmed(RDVId, nom, type, desuet);
        return;
    }

}
window.CancelRDV = CancelRDV;

/**
 * Confirmation de l'annulation d'un RDV
 * @param {any} RDVId   Id du rdv
 * @param {any} nom     Nom de la collecte du rdv a annuler
 * @param {any} type    Type de don
 * @param {boolean} desuet  S'il s'agit d'un rdv désuet
 */
function CancelConfirmed(RDVId, nom, type, desuet, typeCol) {

    $("#mi-modal").modal('hide');

    cancelRendezVousAsync(RDVId).then(function (data) {

        if (data = 'true') {

            toastr.options = {
                "positionClass": "toast-top-center",
                "timeOut": "1000"
            };
            toastr.options.onHidden = function (item) {

                var typeFR;

                switch (type.toLowerCase()) {
                    case 'blood':
                        typeFR = 'sang';
                        break;
                    case 'platelets':
                        typeFR = 'plaquettes';
                        break;

                    default:
                        typeFR = type;
                }


                if (typeCol == '3') {
                    Analytics('gaEvent', 'rendez-vous', 'annulation de rendez-vous | collecte mobile | ' + typeFR, 'confirmer l\'annulation | ' + nom);
                } else {
                    Analytics('gaEvent', 'rendez-vous', 'annulation de rendez-vous | ' + typeFR, 'confirmer l\'annulation | ' + nom);
                }



                if (desuet) {
                    window.location.replace('/ou-donner');
                } else {
                    window.location.replace('/mes-rendez-vous');
                }

            }

            toastr.success(RDVCanceled, SuccessMsg);

        } else {
            location.href = '/StatusCode/500';
        }

    });

}
window.CancelConfirmed = CancelConfirmed;